import { App, notification as staticNotification } from 'antd';
import type { NotificationInstance } from 'antd/es/notification/interface';

let notification: NotificationInstance = staticNotification;

export function AntdGlobal() {
  const { notification: appNotification } = App.useApp();
  notification = appNotification;

  return null;
}

export { notification };
